import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { TableInfoService } from 'tnx-admin-service/tableinfo/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, ModelSchema } from 'tnx-shared';
@Component({
    selector: 'tableinfo',
    templateUrl: './tableinfo.component.html',
    styleUrls: ['./tableinfo.component.scss'],
    providers: [ComponentContextService],
})
export class TableInfoComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _tableInfoService: TableInfoService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._tableInfoService;
        this.setting.objectName = 'Bảng';
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'ten', name: 'Tên bảng', fullName: 'Tên bảng', description: 'Tên bảng' }),
            new ModelSchema({ field: 'code', name: 'Mã bảng', fullName: 'Mã bảng', description: 'Mã bảng' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'ten' }),
            new ColumnSchemaBase({ field: 'code' })
        ];

        super.ngOnInit();
    }
}

